let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("30JEs")).then(() => parcelRequire('5sSOO'));